import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { FunnelServiceService } from '../../../modules/funnel/service/funnel-service.service';
import { AuthUtilsService } from '../../../core/util/auth-utils.service';
import { HttpClient } from '@angular/common/http';
import { SalesOrderServiceService } from '../../../modules/sales-order/service/sales-order-service.service';
import { FileUtilService } from '../../../core/service/FileUtil/file-util.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonSelectListService } from '../../service/common-select-list.service';
import { OrgProfileModal } from '../../../modules/org-profile/modal/org-profile-modal';
import { ResponseCode } from '../../../core/constant/response-code';
import { soModuleParamConfigModel } from '../../../modules/sales-order/modal/so-module-param-config-model';
import { ModuleParamGlobConfigService } from '../../../core/service/moduleFieldConfig/module-param-glob-config.service';

@Component({
  selector: 'app-ng2-smart-table-label',
  templateUrl: './ng2-smart-table-label.component.html',
  styleUrls: ['./ng2-smart-table-label.component.css'],
})
export class Ng2SmartTableLabelComponent implements OnInit {
  renderValue: string;
  status: boolean;

  @Input() value: string | number;
  @Input() rowData: any;

  @Output() save: EventEmitter<any> = new EventEmitter();

  moduleParamModel: soModuleParamConfigModel = new soModuleParamConfigModel(this.moduleParamConfigGlobService);
  moduleName: string;

  constructor(
    public funnelService: FunnelServiceService,
    public commonService: CommonSelectListService,
    public toastrService: ToastrService,
    private moduleParamConfigGlobService: ModuleParamGlobConfigService,
    public router: Router
  ) {}

  ngOnInit() {
    this.moduleName = this.rowData && this.rowData.moduleName ? this.rowData.moduleName : '';
    this.status = this.rowData && this.rowData.status ? this.rowData.status : false;
    this.renderValue = this.value ? this.value.toString().toUpperCase() : '';
  }

  onClick() {
    this.save.emit(this.rowData);
  }

  onClickDownload(referencedDocument: any) {
    // let download = true;
    // let mthis = this;
    window.open(environment.DOWNLOAD_GET_FILE + referencedDocument, '_blank');
    // this.funnelService.downloadFile(referencedDocument).subscribe(
    //     (response) => {
    //       mthis.router.navigate([]).then(result => {
    //         window.open(environment.DOWNLOAD_GET_FILE + referencedDocument, '_blank');
    //       });
    //     },
    //     (error) => {
    //       if (error.status === 500 || error.status === 404) {
    //         this.toastrService.error('File not found', 'ERROR');
    //         return download = false;
    //       }
    //     }
    // );
  }

  onClickPreview(imgUrl: any) {
    window.open(imgUrl, '_blank');
  }

  onClickSetDefault(rowData: OrgProfileModal) {
    rowData.isDefault = !rowData.isDefault;
    this.commonService.setDefaultOrg(rowData).subscribe((res) => {
      if (res.responseCode === 304) {
        this.toastrService.warning(res.responseMessage, 'WARNING');
        this.save.emit(rowData);
        return;
      }
      if (res.responseCode === ResponseCode.OK) {
        this.toastrService.success(res.responseMessage, 'SUCCESS');
        this.save.emit(rowData);
      } else {
        if (confirm(res.responseMessage)) {
          rowData.isDefault = !rowData.isDefault;
          rowData.isForcefullySetDefault = true;
          this.onClickSetDefault(rowData);
        }
        this.save.emit(rowData);
      }
    });
  }
}
